export const environment = {
  production: false,
  authServiceUrl: 'https://spb-common-api-test.internal.sparbankensyd.se/service',
  irApiUrl: 'https://api-ir-ng-be-hakan.internal.sparbankensyd.se/api',
  morningstarApiUrl: 'https://fondlistan-test.spara.sparbankensyd.se/main',
  bvArn: 'arn:aws:lambda:eu-west-1:225460548507:function:bolagsverket-api-test',
  domain: 'ir2-test.internal.sparbankensyd.se',
  testMode: true
}
